module.exports = __webpack_public_path__ + "img/DirectionsCarFilledOutlined.22fd767c.svg";